import { nanoid } from "nanoid";
import { useState } from "react";
import classes from "./Footer.module.scss";
import classnames from "classnames";
import Divider from "../../core/Divider/Divider";
import CustomImage from "../../core/CustomImage/CustomImage";
import logo from "../../../assets/icons/logo.svg";
import facebook from "../../../assets/icons/facebook.svg";
import twitter from "../../../assets/icons/twitter.svg";
import LinkedIn from "../../../assets/icons/in.svg";
import { APP_PATH } from "../../../routes/route";
import { useNavigate } from "react-router";
import { footer } from "../../../global/constant";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const Footer = ({ page = "home", className }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(page);

  const handleClick = (e, link) => {
    if (link.id) {
      setActiveTab(link.id);
      if (link.openInNewTab) {
        window.open(link.id);
      } else {
        navigate(`${APP_PATH}/${link.id}`);
      }
    }
    window.location.reload();
    e.stopPropagation();
  };

  return (
    <div className={classnames(classes.main__container, className)}>
      <div className={classnames(classes.container, "containerWidth")}>
        <div className={classes.addressSection}>
          {/* <CustomImage
            src={logo}
            alt="Paytm Cloud Solution"
            title="Paytm Cloud Solution"
            height={30}
          /> */}
          <div className={classnames(classes.headline)}>Address</div>
          <p className={classes.address}>
            One Skymark, Sector 98 noida Floor No.6 to 22,
            <br /> Tower-D, Plot no H-10 B, Noida, Uttar Pradesh <br />
            201301
          </p>
        </div>
        {footer.map(a => {
          return (
            <div key={nanoid()} className={classnames(classes.links)}>
              <div className={classnames(classes.headline)}>{a.topic}</div>
              <ul className={classnames(classes.list)}>
                {a.links.map(b => {
                  return (
                    <li key={nanoid()} onClick={e => handleClick(e, b)}>
                      {b.name}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
        <div className={classnames(classes.social__media)}>
          <CustomImage
            src={facebook}
            alt="Facebook"
            title="Facebook"
            height={20}
          />
          <CustomImage
            src={twitter}
            alt="Twitter"
            title="Twitter"
            height={20}
          />
          <CustomImage
            src={LinkedIn}
            alt="LinkedIn"
            title="LinkedIn"
            height={20}
          />
        </div>
      </div>
      <Divider />
      <div className={classnames("containerWidth")}>
        <div className={classnames(classes.copyright_TnC)}>
          <div>© 2023 Paytm Cloud Solution. All rights reserved.</div>
          <div className={classnames(classes.TnC_PP)}>
            <a onClick={() => navigate(`${APP_PATH}/termsofservice`)}>
              Terms of Service
            </a>{" "}
            |{" "}
            <a onClick={() => navigate(`${APP_PATH}/privacypolicy`)}>
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
